import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { TreatmentMethod } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<TreatmentMethod.Basic>> =>
	Http.get(baseUrl, { params })

export const retrieveTreatmentMethodsMostUsed = (): Promise<TreatmentMethod.MostUsed[]> =>
	Http.get(`${baseUrl}/most-used`)

export const downloadOverviewDocument = (): Promise<ArrayBuffer> =>
	Http.get(`${baseUrl}/overview-document/download`, {
		responseType: 'arraybuffer'
	})
